import React, { memo, useState, useEffect } from 'react';
import { getLeaderboard, getDailyLeaderboard } from '../services/api';

function Leaderboard({ onBack }) {
  const [tab, setTab] = useState('alltime'); // alltime, daily
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    async function fetchData() {
      setLoading(true);
      setError(null);
      try {
        const data = tab === 'alltime'
          ? await getLeaderboard(50)
          : await getDailyLeaderboard();

        if (!cancelled && data) {
          setEntries(data.entries || []);
        }
      } catch (err) {
        if (!cancelled) setError('Failed to load leaderboard');
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    fetchData();
    return () => { cancelled = true; };
  }, [tab]);

  return (
    <div className="leaderboard-screen">
      <div className="leaderboard-card">
        <div className="leaderboard-header">
          <button className="back-btn" onClick={onBack} aria-label="Back to menu">
            &#8592;
          </button>
          <h2 className="leaderboard-title">LEADERBOARD</h2>
        </div>

        <div className="leaderboard-tabs">
          <button
            className={`tab-btn ${tab === 'alltime' ? 'tab-active' : ''}`}
            onClick={() => setTab('alltime')}
          >
            All Time
          </button>
          <button
            className={`tab-btn ${tab === 'daily' ? 'tab-active' : ''}`}
            onClick={() => setTab('daily')}
          >
            Today
          </button>
        </div>

        <div className="leaderboard-list">
          {loading && <div className="leaderboard-empty">Loading...</div>}
          {error && <div className="leaderboard-empty">{error}</div>}
          {!loading && !error && entries.length === 0 && (
            <div className="leaderboard-empty">No scores yet. Be the first!</div>
          )}
          {!loading && !error && entries.map((entry, i) => (
            <div key={i} className={`leaderboard-row ${i < 3 ? 'leaderboard-top' : ''}`}>
              <span className={`leaderboard-rank rank-${i + 1}`}>
                {i === 0 ? '\u{1F947}' : i === 1 ? '\u{1F948}' : i === 2 ? '\u{1F949}' : `#${entry.rank}`}
              </span>
              <span className="leaderboard-name">{entry.displayName}</span>
              <span className="leaderboard-score">{entry.score?.toLocaleString()}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default memo(Leaderboard);
